import { getBaseUrl } from "helpers/url";

import IntroVideo from "assets/videos/Pointless_React_Intro_Video_4.mp4";
import TransitionMenuR1 from "assets/videos/Transition-Menu-R1.mp4";
import TransitionR1R2 from "assets/videos/Transition-R1-R2.mp4";
import TransitionR2R3 from "assets/videos/Transition-R2-R3.mp4";
import TransitionR3R4 from "assets/videos/Transition-R3-R4.mp4";
import PointlessAnswerR1R2 from "assets/videos/Pointless Answer_R1_And_R2_SOUND_V2.mp4";
import PointlessAnswerR3 from "assets/videos/Pointless Answer_R3_SOUND_V2.mp4";
import PointlessAnswerR4 from "assets/videos/Pointless Answer_R4_SOUND_V2.mp4";
import PointlessAnswerFR from "assets/videos/Final_Pointless_Answer_V1.mp4";
import FinalTransition1 from "assets/videos/Contestant_Results_1_Podium.mp4";
import FinalTransition2 from "assets/videos/Contestant_Results_2_Podium.mp4";
import FinalTransition3 from "assets/videos/Contestant_Results_3_Podium.mp4";
import FinalTransition4 from "assets/videos/Contestant_Results_4_Podium.mp4";
import TrophyVideo from "assets/videos/TrophyV2_Reveal.mp4";
import FinalWrongAnswer from "assets/videos/Wrong_Answer_FR.mp4";
import FinalNotPointless from "assets/videos/Not_Pointless_FR_GameOver.mp4";
import FinalWrongAnswerEndGame from "assets/videos/Wrong_Answer_FR_EndGame.mp4";
import WrongAnswerR1R2 from "assets/videos/Wrong_Answer R1_2.mp4"
import WrongAnswerR3 from "assets/videos/Wrong_Answer R3.mp4"
import WrongAnswerR4 from "assets/videos/Wrong_Answer R4.mp4"
import WrongAnswerR1R2LQ from "assets/videos/Wrong_Answer R1_R2_LQ.mp4"
import WrongAnswerR3LQ from "assets/videos/Wrong_Answer R3_LQ.mp4"
import WrongAnswerR4LQ from "assets/videos/Wrong_Answer R4_LQ.mp4"

import IntroVideoAudio from "assets/videoAudio/Pointless_React_Intro_Video.mp3";
import TransitionMenuR1Audio from "assets/videoAudio/Transition-Menu-R1.mp3";
import TransitionR1R2Audio from "assets/videoAudio/Transition-R1-R2.mp3";
import TransitionR2R3Audio from "assets/videoAudio/Transition-R2-R3.mp3";
import TransitionR3R4Audio from "assets/videoAudio/Transition-R3-R4.mp3";
import PointlessAnswerR1R2Audio from "assets/videoAudio/Pointless Answer_R1_And_R2_SOUND_V2.mp3";
import PointlessAnswerR3Audio from "assets/videoAudio/Pointless Answer_R3_SOUND_V2.mp3";
import PointlessAnswerR4Audio from "assets/videoAudio/Pointless Answer_R4_SOUND_V2.mp3";
import PointlessAnswerFRAudio from "assets/videoAudio/Final_Pointless_Answer_V1.mp3";
import FinalTransitionVideoAudio from "assets/videoAudio/Contestant_Results_Transition_V3.mp3";
import TrophyVideoAudio from "assets/videoAudio/TrophyV2_Reveal.mp3";
import FinalWrongAnswerAudio from "assets/videoAudio/Wrong_Answer_FR.mp3";
import FinalNotPointlessAudio from "assets/videoAudio/Not_Pointless_FR_GameOver.mp3";
import FinalWrongAnswerEndGameAudio from "assets/videoAudio/Wrong_Answer_FR_EndGame.mp3";
import WrongAnswerR1R2Audio from "assets/videoAudio/Wrong_Answer R1_2.mp3"
import WrongAnswerR3Audio from "assets/videoAudio/Wrong_Answer R3.mp3"
import WrongAnswerR4Audio from "assets/videoAudio/Wrong_Answer R4.mp3"

// Shared images
import mutedIcon from "images/Shared/lobby_muted.png";
import unmutedIcon from "images/Shared/lobby_unmuted.png";
import fullscreenIcon from "images/Shared/lobby_fullscreen.png";
import menuIcon from "images/Shared/lobby_menu.png";
import helpIcon from "images/Shared/lobby_help.png";
import GCLogoWhite from "images/Shared/gc_logo_white.png";
import GCLogoBlack from "images/Shared/gc_logo_black.png";

import countdownDivider from "images/Host/Countdown/Divider.png";
import capsule from "images/Host/Question_Container_LONG_FULL.png";
import categoryCapsule from "images/Host/High res_Question_Container.png";
import largeCapsule from "images/Host/Large_Capsule.png";
import teamStand from "images/Host/stand.png";
import podiumBlank from "images/Host/Player_Stand_Blank.png";
import podium1 from "images/Host/Player_Stand_01.png";
import podium2 from "images/Host/Player_Stand_02.png";
import podium3 from "images/Host/Player_Stand_03.png";
import podium4 from "images/Host/Player_Stand_04.png";
import answerCapsule from "images/Host/AnswerContainer.png";

import EmptyBG from "images/Pointless_React_Intro_STILL_00390.jpg";
import IntroBG from "images/Host/Pointless_React_Intro_STILL.jpg";
import GameOverTrohpyBG from "images/Host/Pointless_Answer_Trophy_EndScreen.jpg";
import GameOverLostBG from "images/Host/Not_Pointeless_FR_NoTrophy_EndScreen.jpg";

import R1R2BG from "images/Host/Scoreboards/Scoreboard_R1_R2.jpg";
import R3BG from "images/Host/Scoreboards/Scoreboard_R3.jpg";
import R4BG from "images/Host/Scoreboards/Scoreboard_R4.jpg";
//import WrongBG from "images/Host/Scoreboards/Scoreboard_Wrong.jpg";

import ButtonGlow from "images/Pointless_React_Intro_ButtonGlow.png";
import StandGlow from "images/Pointless_PlayerStand_Glow.png";

// Pointless Answer Assets
import PointlessContestantCorner from "images/Host/Countdown/POINTLESS/POINTLESS_Contestant_BG.png";
import PointlessColumnCorner from "images/Host/Countdown/POINTLESS/POINTLESS_Column_BG.png";
// Whiteout Answer Assets
import WhiteoutContestantCorner from "images/Host/Countdown/WHITEOUT/WHITEOUT_Contestant_BG.png";
import WhiteoutColumnCorner from "images/Host/Countdown/WHITEOUT/WHITEOUT_Column_BG.png";

// R1+R2 Assets
import R1R2ContestantCorner from "images/Host/Countdown/R1R2/R1R2_Contestant_BG.png";
import R1R2ColumnCorner from "images/Host/Countdown/R1R2/R1R2_Column_BG.png";
import R1R2ColumnCornerLQ from "images/Host/Countdown/R1R2/R1_R2_Column_BG_LQ.png";
import R1R2WrongColumnCorner from "images/Host/Countdown/R1R2/Wrong_Answer_Column_R1_R2.jpg";
import R1R2WrongColumnCornerLQ from "images/Host/Countdown/R1R2/Wrong_Answer R1_R2_STILL_LQ.jpg";
// R3 Assets
import R3ContestantCorner from "images/Host/Countdown/R3/R3_Contestant_BG.png";
import R3ColumnCorner from "images/Host/Countdown/R3/R3_Column_BG.png";
import R3ColumnCornerLQ from "images/Host/Countdown/R3/R3_Column_BG_LQ.png";
import R3WrongColumnCorner from "images/Host/Countdown/R3/Wrong_Answer_Column_R3.jpg";
import R3WrongColumnCornerLQ from "images/Host/Countdown/R3/Wrong_Answer R3_STILL_LQ.jpg";
// R4 Assets
import R4ContestantCorner from "images/Host/Countdown/R4/R4_Contestant_BG.png";
import R4ColumnCorner from "images/Host/Countdown/R4/R4_Column_BG.png";
import R4ColumnCornerLQ from "images/Host/Countdown/R4/R4_Column_BG_LQ.png";
import R4WrongColumnCorner from "images/Host/Countdown/R4/Wrong_Answer_Column_R4.jpg";
import R4WrongColumnCornerLQ from "images/Host/Countdown/R4/Wrong_Answer R4_STILL_LQ.jpg";
// WRONG Assets
import WRONGContestantCorner from "images/Host/Countdown/WRONG/WRONG_Contestant_BG.png";
import WRONGColumnCorner from "images/Host/Countdown/WRONG/WRONG_Column_BG.png";

import R1R2BlueColumn from "images/Host/Countdown/R1R2/R1R2_Column_BG_BLUE.png";
import R3BlueColumn from "images/Host/Countdown/R3/R3_Column_BG_BLUE.png";
import R4BlueColumn from "images/Host/Countdown/R4/R4_Column_BG_BLUE.png";

// Clock Assets
import ClockR1 from "images/Host/Clocks/Round-1.png";
import ClockR2 from "images/Host/Clocks/Round-2.png";
import ClockR3 from "images/Host/Clocks/Round-3.png";
import ClockR4 from "images/Host/Clocks/Round-4.png";
import ClockFR from "images/Host/Clocks/Final-Round.png";
import ClockCircle from "images/Host/Clocks/Round_Clock.png";

// Final Round
import FinalIntroBG1 from "images/Host/FinalRound/Contestant_Results_1_Podiums.jpg";
import FinalIntroBG2 from "images/Host/FinalRound/Contestant_Results_2_Podiums.jpg";
import FinalIntroBG3 from "images/Host/FinalRound/Contestant_Results_3_Podiums.jpg";
import FinalIntroBG4 from "images/Host/FinalRound/Contestant_Results_4_Podiums.jpg";
import FinalRoundBase from "images/Host/FinalRound/Final_Round_SkyBlue.jpg";
import FinalRoundBlue from "images/Host/FinalRound/Final_Round_BLUE.jpg";
import FinalRoundPointless from "images/Host/FinalRound/Final_Round_Green.jpg";
import FinalRoundFlash from "images/Host/FinalRound/Final_Round_White.jpg";
import FinalWrongStill from "images/Host/FinalRound/Wrong_Answer_FR_STILL.jpg";

import BlackStill from "images/Host/Black_STILL.jpg";
import WhiteStill from "images/Host/White_STILL.jpg";

import PointlessLogo from "images/logo.png";


export const IMAGES = {
    SHARED: {
        EmptyBG,
        GCLogoWhite,
        GCLogoBlack,
        mutedIcon,
        unmutedIcon,
        fullscreenIcon,
        menuIcon,
        helpIcon,
        PointlessLogo,
    },
    HOST: {
        // General UI Assets
        countdownDivider,
        capsule,
        categoryCapsule,
        largeCapsule,
        teamStand,
        podiumBlank,
        podium1,
        podium2,
        podium3,
        podium4,
        answerCapsule,

        // Backgrounds
        EmptyBG,
        IntroBG,
        GameOverTrohpyBG,
        GameOverLostBG,
        WhiteStill,
        BlackStill,

        // Scoreboard Backgrounds
        R1R2BG,
        R3BG,
        R4BG,
        // WrongBG, // Uncomment if used

        // Glows & Effects
        ButtonGlow,
        StandGlow,

        // Pointless Answer Assets
        PointlessContestantCorner,
        PointlessColumnCorner,

        // Whiteout Answer Assets
        WhiteoutContestantCorner,
        WhiteoutColumnCorner,

        // R1 + R2 Assets
        R1R2ContestantCorner,
        R1R2ColumnCorner,
        R1R2ColumnCornerLQ,
        R1R2BlueColumn,
        R1R2WrongColumnCorner,
        R1R2WrongColumnCornerLQ,

        // R3 Assets
        R3ContestantCorner,
        R3ColumnCorner,
        R3ColumnCornerLQ,
        R3BlueColumn,
        R3WrongColumnCorner,
        R3WrongColumnCornerLQ,

        // R4 Assets
        R4ContestantCorner,
        R4ColumnCorner,
        R4ColumnCornerLQ,
        R4BlueColumn,
        R4WrongColumnCorner,
        R4WrongColumnCornerLQ,

        // WRONG Assets
        WRONGContestantCorner,
        WRONGColumnCorner,

        // Clock Assets
        ClockR1,
        ClockR2,
        ClockR3,
        ClockR4,
        ClockFR,
        ClockCircle,

        // Final Round
        FinalIntroBG1,
        FinalIntroBG2,
        FinalIntroBG3,
        FinalIntroBG4,
        FinalRoundBase,
        FinalRoundBlue,
        FinalRoundPointless,
        FinalRoundFlash,
        FinalWrongStill
    },
    CLIENT: {

    },
};

const baseUrl = getBaseUrl();

export const FONTS = [
    { font: "Avant", path: `${baseUrl}/Assets/ITC-AVANT-GARDE-GOTHIC-BOLD.OTF`},
];

export const VIDEOS = {
    INTRO: {
        src: IntroVideo,
        volume: 0.5,
        fallbackAudio: {
            src: IntroVideoAudio,
            volume: 0.5,
        },
        posterImage: null,
    },
    // ROUND_INTRO: {
    //     src: RoundIntroVideo,
    //     fallbackAudio: {
    //         src: roundIntroVideoFallbackAudio,
    //         volume: 0.5,
    //     },
    //     posterImage: IMAGES.HOST.hostSplash,
    // },
    POINTLESS_ANSWER_R1: {
        src: PointlessAnswerR1R2,
        volume: 0.5,
        fallbackAudio: {
            src: PointlessAnswerR1R2Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.WhiteStill,
    },
    POINTLESS_ANSWER_R2: {
        src: PointlessAnswerR1R2,
        volume: 0.5,
        fallbackAudio: {
            src: PointlessAnswerR1R2Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.WhiteStill,
    },
    POINTLESS_ANSWER_R3: {
        src: PointlessAnswerR3,
        volume: 0.5,
        fallbackAudio: {
            src: PointlessAnswerR3Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.WhiteStill,
    },
    POINTLESS_ANSWER_R4: {
        src: PointlessAnswerR4,
        volume: 0.5,
        fallbackAudio: {
            src: PointlessAnswerR4Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.WhiteStill,
    },
    POINTLESS_ANSWER_FR: {
        src: PointlessAnswerFR,
        volume: 0.5,
        fallbackAudio: {
            src: PointlessAnswerFRAudio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.FinalRoundPointless,
    },
    WRONG_ANSWER_R1_R2: {
        src: WrongAnswerR1R2,
        volume: 0.65,
        fallbackAudio: {
            src: WrongAnswerR1R2Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R1R2WrongColumnCorner,
    },
    WRONG_ANSWER_R1_R2_LQ: {
        src: WrongAnswerR1R2LQ,
        volume: 0.65,
        fallbackAudio: {
            src: WrongAnswerR1R2Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R1R2WrongColumnCornerLQ,
    },
    WRONG_ANSWER_R3: {
        src: WrongAnswerR3,
        volume: 0.65,
        fallbackAudio: {
            src: WrongAnswerR3Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R3WrongColumnCorner,
    },
    WRONG_ANSWER_R3_LQ: {
        src: WrongAnswerR3LQ,
        volume: 0.65,
        fallbackAudio: {
            src: WrongAnswerR3Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R3WrongColumnCornerLQ,
    },
    WRONG_ANSWER_R4: {
        src: WrongAnswerR4,
        volume: 0.65,
        fallbackAudio: {
            src: WrongAnswerR4Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R4WrongColumnCorner,
    },
    WRONG_ANSWER_R4_LQ: {
        src: WrongAnswerR4LQ,
        volume: 0.65,
        fallbackAudio: {
            src: WrongAnswerR4Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R4WrongColumnCornerLQ,
    },
    TRANSITION_MENU_R1: {
        src: TransitionMenuR1,
        volume: 0.5,
        fallbackAudio: {
            src: TransitionMenuR1Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.IntroBG,
    },
    TRANSITION_R1_R2: {
        src: TransitionR1R2,
        volume: 0.5,
        fallbackAudio: {
            src: TransitionR1R2Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R1R2BG,
    },
    TRANSITION_R2_R3: {
        src: TransitionR2R3,
        volume: 0.5,
        fallbackAudio: {
            src: TransitionR2R3Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R1R2BG,
    },
    TRANSITION_R3_R4: {
        src: TransitionR3R4,
        volume: 0.5,
        fallbackAudio: {
            src: TransitionR3R4Audio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R3BG,
    },
    FINAL_TRANSITION_1: {
        src: FinalTransition1,
        volume: 0.5,
        fallbackAudio: {
            src: FinalTransitionVideoAudio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R4BG,
    },
    FINAL_TRANSITION_2: {
        src: FinalTransition2,
        volume: 0.5,
        fallbackAudio: {
            src: FinalTransitionVideoAudio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R4BG,
    },
    FINAL_TRANSITION_3: {
        src: FinalTransition3,
        volume: 0.5,
        fallbackAudio: {
            src: FinalTransitionVideoAudio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R4BG,
    },
    FINAL_TRANSITION_4: {
        src: FinalTransition4,
        volume: 0.5,
        fallbackAudio: {
            src: FinalTransitionVideoAudio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.R4BG,
    },
    TROPHY: {
        src: TrophyVideo,
        volume: 0.5,
        fallbackAudio: {
            src: TrophyVideoAudio,
            volume: 0.5,
        },
        // No poster: the trophy is a separate shot that intentionally fades up
        // from black. A black poster would snap on instantly and hide the
        // gradual .stillBG.main fade-out, producing a hard cut to black. With no
        // poster, the scene eases to black over 500ms and then flows straight
        // into the video's own fade-in.
        posterImage: null,
    },
    FINAL_WRONG_ANSWER: {
        src: FinalWrongAnswer,
        volume: 0.65,
        fallbackAudio: {
            src: FinalWrongAnswerAudio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.FinalWrongStill,
    },
    FINAL_WRONG_ANSWER_END_GAME: {
        src: FinalWrongAnswerEndGame,
        volume: 0.65,
        fallbackAudio: {
            src: FinalWrongAnswerEndGameAudio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.FinalWrongStill,
    },
    FINAL_NOT_POINTLESS_GAME_OVER: {
        src: FinalNotPointless,
        volume: 0.65,
        fallbackAudio: {
            src: FinalNotPointlessAudio,
            volume: 0.5,
        },
        posterImage: IMAGES.HOST.FinalWrongStill,
    }
};

// Timed events fired during video playback, keyed by VIDEOS key.
// Each entry: { time (seconds), type (identifier the Host switches on) }.
// The Host maps these to { time, handler } and passes them to <VideoPlayer>.
// FINAL_TRANSITION_* videos (Contestant_Results_*_Podium.mp4) contain a white
// flash peaking at 5s 18f @ 24fps = 5.75s — the moment to reveal the podium
// avatars + rank text so they read as part of the video.
export const VIDEO_EVENTS = {
    FINAL_TRANSITION_1: [{ time: 5.75, type: "REVEAL_FINAL_PODIUMS" }],
    FINAL_TRANSITION_2: [{ time: 5.75, type: "REVEAL_FINAL_PODIUMS" }],
    FINAL_TRANSITION_3: [{ time: 5.75, type: "REVEAL_FINAL_PODIUMS" }],
    FINAL_TRANSITION_4: [{ time: 5.75, type: "REVEAL_FINAL_PODIUMS" }],
    // TrophyV2_Reveal.mp4 crossfades between two camera angles ending on the
    // final-round static shot; at 6s 19f @ 24fps = 6.79s the crossfade begins,
    // so we start fading the live countdown tower in to link the video to the
    // gameplay view.
    TROPHY: [{ time: 6.79, type: "FADE_COUNTDOWN_TOWER" }],
};

export const REQUIRED_PLAYERS = 1;
export const MAX_PLAYERS = 8;
export const GAME_ID = "pointless";

export const GAME_STATES = {
    PRE_LOAD: "PRE_LOAD",
    TUTORIAL: "TUTORIAL",
    MENU: 'MENU',
    LOADING: 'LOADING',

    ROUND_INTRO: "ROUND_INTRO",
    CATEGORY_DISPLAY: "CATEGORY_DISPLAY",
    DETAILED_DISPLAY: "DETAILED_DISPLAY",
    QUESTION_DISPLAY: "QUESTION_DISPLAY",
    ANSWERING: "ANSWERING",
    ANSWER_IDLE: "ANSWER_IDLE",

    REVEAL_ANSWER: "REVEAL_ANSWER",

    ROUND_SUMMARY: "ROUND_SUMMARY",

    FINAL_ROUND_INTRO: "FINAL_ROUND_INTRO",
    FINAL_ROUND: "FINAL_ROUND",
    FINAL_ROUND_CATEGORY_SELECT: "FINAL_ROUND_CATEGORY_SELECT",
    FINAL_ROUND_QUESTION_DISPLAY: "FINAL_ROUND_QUESTION_DISPLAY",
    FINAL_ROUND_ANSWERING: "FINAL_ROUND_ANSWERING",
    FINAL_ROUND_SELECT: "FINAL_ROUND_SELECT",
    FINAL_ANSWER_IDLE: "FINAL_ANSWER_IDLE",
    FINAL_ROUND_REVEAL: "FINAL_ROUND_REVEAL",
    FINAL_ROUND_SUMMARY: "FINAL_ROUND_SUMMARY",

    GAME_OVER_IDLE: 'GAME_OVER_IDLE',
    GAME_OVER: 'GAME_OVER',
    END_GAME: "END_GAME",
};

export const MESSAGES = {
    // Messages sent from client to server
    TO_SERVER: {
        HOST_LOADED: "POINTLESS_HOST_LOADED",
        LOADING_COMPLETE: "POINTLESS_LOADING_COMPLETE",

        SELECT_TEAM: "POINTLESS_SELECT_TEAM",
        START_GAME: "POINTLESS_START_GAME",
        BEGIN_ROUND: "POINTLESS_BEGIN_ROUND",
        START_PRE_ROUND: "POINTLESS_START_PRE_ROUND",
        END_PRE_ROUND: "POINTLESS_END_PRE_ROUND",
        BEGIN_ANSWERING: "POINTLESS_BEGIN_ANSWERING",

        SUBMIT_ANSWER: "POINTLESS_SUBMIT_ANSWER",
        VOTE_ANSWER: "POINTLESS_VOTE_ANSWER",
        CONFIRM_ANSWER: "POINTLESS_CONFIRM_ANSWER",

        UPDATE_DROP_SCORE: "POINTLESS_UPDATE_DROP_SCORE",
        COMPLETE_DROP: "POINTLESS_COMPLETE_DROP",
        COMPLETE_SUMMARY: "POINTLESS_COMPLETE_SUMMARY",
        VOTE_MOVE_ON: "POINTLESS_VOTE_MOVE_ON",


        MOVE_ON_FINAL: "POINTLESS_MOVE_ON_FINAL",
        BEGIN_FINAL_CATEGORY_SELECT: "POINTLESS_BEGIN_FINAL_CATEGORY_SELECT",
        SELECT_FINAL_CATEGORY: "POINTLESS_SELECT_FINAL_CATEGORY",
        BEGIN_FINAL_ANSWERING: "POINTLESS_BEGIN_FINAL_ANSWERING",

        END_GAME: "POINTLESS_END_GAME",
        NEW_GAME: "POINTLESS_NEW_GAME",

        MUTE_MUSIC: "POINTLESS_MUTE_MUSIC",
        MUTE_MUSIC_CONFIRMED: "POINTLESS_MUTE_MUSIC_CONFIRMED",
        MUTE_SFX: "POINTLESS_MUTE_SFX",
        MUTE_SFX_CONFIRMED: "POINTLESS_MUTE_SFX_CONFIRMED",
        
        DEBUG_NEXT_QUESTION: "POINTLESS_DEBUG_NEXT_QUESTION",

        CHANGE_GAME: "change_game",
    },
    // Messages sent from server to client
    TO_CLIENTS: {
        SEND_CONFIRM_ANSWER: "POINTLESS_SEND_CONFIRM_ANSWER",
        SEND_SUGGEST_ANSWER: "POINTLESS_SEND_SUGGEST_ANSWER",
        MUTE_MUSIC: "POINTLESS_MUTE_MUSIC",
        MUTE_SFX: "POINTLESS_MUTE_SFX",
    }
};

export const QuestionTypes = {
    SINGLE: "_SINGLE",
    GROUP: "_GROUP",
    FINAL: "_FINAL",
};


export const WS_ERROR_CODES = {
    1001: "Browser Tab Closing",
    1002: "Malformed framce received",
    1003: "Unsupported frame received",
    1006: "GS ungraceful shutdown / connection refused",
    1011: "Internal Error",
    1012: "Server Restarting",
    1013: "Try again later, server capacity full",
    1014: "Bad Gateway",
    4000: "Gameserver graceful shutdown",
    4050: "Player removed"
};